import { differenceInYears, isValid, parseISO } from 'date-fns';

const MAX_PLAUSIBLE_AGE = 120;
const CALENDAR_DATE_PREFIX = /^\d{4}-\d{2}-\d{2}/;

// Whole years from a stored date to `today`, or null when there is no sensible age: a
// missing or unparseable value, a future date, or one over 120 years ago. Only the
// calendar date is read, so a midnight-UTC timestamp cannot shift a birthday by a day.
export const getAgeInYears = (
  value: unknown,
  today: Date = new Date()
): number | null => {
  if (typeof value !== 'string' || !isValid(parseISO(value))) return null;

  const calendarDate = value.match(CALENDAR_DATE_PREFIX)?.[0] ?? value;
  const date = parseISO(calendarDate);
  if (date > today) return null;

  const age = differenceInYears(today, date);
  return age <= MAX_PLAUSIBLE_AGE ? age : null;
};
